import $ from "jquery";
import * as d3 from "d3";
import {host} from "../../utils/globals";
import {connect} from "react-redux";
import * as topojson from "topojson";
import React, {Component} from "react";
import {renderToString} from 'react-dom/server'
import Select from 'react-select';
import PoActivities from "./PoActivities";
import PoActivityStatus from "./PoActivityStatus";
import {convertArrayToCSV} from "convert-array-to-csv";
import download from "downloadjs";
// import "../homePage/reconstructionMap/reconstructionMap.css";
import "./district.css";
import {
    calculateTranslateAndScale,
    chunkArray,
    requiredCols,
    getColor,
    getTooltipData,
    getDataForReactSelect,
    getCsvFilename
} from "../../utils/helpers";
import {
    MAP_LIST_API_URL,
    INFOGRAPHIC_LIST_API_URL,
    MEETING_LIST_API_URL,
    RESOURCE_MATERIAL_LIST_API_URL,
    DASHBOARD_LIST_API_URL
} from "../../store/constants/urls";
import {
    fetchMapsOnDistrict,
    fetchInfographyOnDistrict
} from "../../store/actions/districtPageAction";
import Team from "./Team";
import VerityOfData from "./VerityOfData";
import {fetchHomePageHrrpReferece} from "../../store/actions/homepageAction";
import {fetchDashboardList} from "../../store/actions/globalActions";
import {FETCH_DASHBOARD_DATA_SUCCESS} from "../../store/constants/actionType";
import PoPresenceLegend from "../common/PoPresenceLegend";
import Tooltip from "../common/Tooltip";

class District extends Component {
    state = {
        svg: null,
        path: null,
        zoom: null,
        zoomScale: null,
        projection: null,
        meeting: "",
        team: "",
        width: 700,
        height: 345,
        originalData: null,
        allCsvData: null,
        partnerOrganizations: null,
        activityTypes: null,
        datas: "",
        resourceMaterials: null,
        paginatedBarData: {
            totalBarPage: "",
            currentBarPage: 1,
            currentBarData: ""
        },
        csvData: null,
        tooltipLoaded: false,
        selectedGapanas: [],
        selectedWards: [],
        selectedPos: [],
        selectedSectors: [],
        selectedActivities: [],
        selectedActivityStatus: [],
        wardCodes: [],
    };

    constructor(props) {
        super(props);
        this.mapManupulation.bind(this);
    }

    poPresenceInnerTextStyle = () => {
        let innerText = document.querySelectorAll(
            ".donutchart .donutchart-innertext > text"
        );
        if (innerText && innerText.length > 0) {
            innerText.forEach((d, i) => {
                let y = i === 0 ? "90%" : "100%";
                d.setAttribute("y", y);
            });
        }
    };

    chageBarData = e => {
        let {
            barData,
            paginatedBarData: {currentBarData, currentBarPage, totalBarPage}
        } = this.state;

        if (e === "down") {
            currentBarData =
                currentBarPage >= 0 && currentBarPage < totalBarPage
                    ? barData && barData.slice(currentBarPage * 8, currentBarPage * 8 + 8)
                    : currentBarData;
            currentBarPage =
                currentBarPage > 0 && currentBarPage < totalBarPage
                    ? currentBarPage + 1
                    : currentBarPage;
        } else {
            currentBarPage = currentBarPage <= 1 ? 1 : currentBarPage - 1;
            currentBarData =
                barData && barData.slice(currentBarPage * 8 - 8, currentBarPage * 8);
        }
        totalBarPage = Math.ceil(barData.length / 8);
        this.setState({
            paginatedBarData: {currentBarData, currentBarPage, totalBarPage}
        });
    };

    fetDashboardData = () => {
        let district = this.props.match.params.id;
        return fetch(DASHBOARD_LIST_API_URL)
            .then(res => res.json())
            .then(res => {
                this.props.dispatch({
                    type: FETCH_DASHBOARD_DATA_SUCCESS,
                    payload: res
                });
                return res;
            })
            .catch(err => {
                this.readCSVFile(district);
                console.log("Dashboard fetch error", err);
            });
    };

    async componentDidMount() {
        let district = this.props.match.params.id;

        let mapUrl = `${MAP_LIST_API_URL}&district_alias=${district}`;
        let infoUrl = `${INFOGRAPHIC_LIST_API_URL}&district_alias=${district}`;

        this.props.dispatch(fetchMapsOnDistrict(mapUrl));
        this.props.dispatch(fetchInfographyOnDistrict(infoUrl));

        this.fetchDatas(district);

        const {mapData} = this.props;

        this.readUpdatedCsvfile();

        if (mapData && mapData.length > 0) {
            this.renderMap(district, mapData);
        } else {
            this.renderMap(district);
        }

        let {isFetched} = this.props.dashboards;
        !isFetched && this.props.dispatch(fetchDashboardList());
    }

    async readUpdatedCsvfile() {
        let district = this.props.match.params.id;
        if (!window.location.host.indexOf("localhost") <= 0) {
            let dashboards = await this.fetDashboardData();
            this.readCSVFile(
                district,
                null,
                dashboards &&
                dashboards["po-activities-5w"] &&
                dashboards["po-activities-5w"].file
            );
            this.props.dispatch({
                type: FETCH_DASHBOARD_DATA_SUCCESS,
                payload: dashboards
            });
        } else {
            this.readCSVFile(district);
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        let {csvData, tooltipLoaded} = this.state;
        let district = this.props.match.params.id;
        let previousDistrict = prevProps.match.params.id;

        if (csvData && !tooltipLoaded) {
            this.setState({tooltipLoaded: true});
            let div = d3.select('body').append('div').attr('class', 'tooltip');
            let g = d3.selectAll("svg#map g");

            g.selectAll('path.current-district').on("mouseover", function (d) {
                let gapanaCode = d && d.properties.N_WCode;
                let tooltipData = getTooltipData({csvData, gapanaCode});
                let tooltipProps = {
                    district: d.properties.DISTRICT,
                    municipality: d.properties.GaPa_NaPa,
                    wardNumber: d.properties.new_ward,
                    ...tooltipData
                };
                let html = renderToString(<Tooltip {...tooltipProps}/>);
                div
                    .transition()
                    .duration(200)
                    .style("opacity", 0.9);
                div
                    .html(html)
                    .style("left", d3.event.pageX + 28 + "px")
                    .style("top", d3.event.pageY - 56 + "px");
            })
                .on("mouseout", () =>
                    div
                        .transition()
                        .duration(500)
                        .style("opacity", 0)
                );
        }

        if (district !== previousDistrict) {
            this.setState({
                selectedGapanas: [],
                selectedWards: [],
                selectedPos: [],
                selectedSectors: [],
                selectedActivities: [],
                selectedActivityStatus: []
            });
            let mapUrl = `${MAP_LIST_API_URL}&district_alias=${district}`;
            let infoUrl = `${INFOGRAPHIC_LIST_API_URL}&district_alias=${district}`;
            this.props.dispatch(fetchMapsOnDistrict(mapUrl));
            this.props.dispatch(fetchInfographyOnDistrict(infoUrl));
            this.props.dispatch(fetchHomePageHrrpReferece());
            this.fetchDatas(district);
            const {mapData} = this.props;

            this.readUpdatedCsvfile();

            if (mapData && mapData.length > 0) {
                this.renderMap(district, mapData);
            } else {
                this.renderMap(district);
            }
        }
    };

    fetchDatas = district => {
        if (district) {
            let self = this;
            let mapUrl = `${MAP_LIST_API_URL}&district_alias=${district}`;
            let infoUrl = `${INFOGRAPHIC_LIST_API_URL}&district_alias=${district}`;
            let meetingUrl = `${MEETING_LIST_API_URL}?district_alias=${district}`;
            let teamURL = `${host}/api/team-by-district/list?district_alias=${district}`;
            let resourceMaterialUrl = `${RESOURCE_MATERIAL_LIST_API_URL}?district_alias=${district}`;

            this.props.dispatch(fetchMapsOnDistrict(mapUrl));
            this.props.dispatch(fetchInfographyOnDistrict(infoUrl));

            fetch(meetingUrl)
                .then(res => res.json())
                .then(data => {
                    if (data) {
                        self.setState({meeting: data});
                    } else {
                        console.log("ERROR");
                    }
                })
                .catch(err => "");

            fetch(resourceMaterialUrl)
                .then(res => res.json())
                .then(data => {
                    if (data) {
                        self.setState({resourceMaterials: data});
                    } else {
                        console.log("ERROR");
                    }
                })
                .catch(err => "");
            fetch(teamURL)
                .then(res => res.json())
                .then(data => {
                    if (data) {
                        self.setState({team: data});
                    } else {
                        console.log("ERROR");
                    }
                })
                .catch(err => "");
        }
    };

    renderMap = (district, mapData) => {
        let self = this;
        !mapData
            ? d3.json("/map/np.json").then(function (data) {
                self.mapManupulation(district, data);
            })
            : this.mapManupulation(district, mapData);
    };

    async getVdcColor() {
        let vdcColor = {};
        return d3.csv("/map/vdcCount.csv").then(data => {
            data && data.forEach(d => {
                vdcColor[d.N_WardCode] = d.PO_Count
            })
            return vdcColor;
        });
    }

    async mapManupulation(district, data) {
        let vdcColor = await this.getVdcColor();

        $("#map-wrapper").html("");
        let {width, height} = this.state;
        let projection = d3.geoMercator();

        this.setState({projection});

        let path = d3.geoPath().projection(projection);

        let svg = d3
            .select("#map-wrapper")
            .append("svg")
            .attr("id", "map")
            .attr("width", "100%")
            .attr("height", height);
        let g = svg.append("g");

        let featureData = topojson.feature(data, data.objects.vulnerablility_wgs);
        let datas = featureData.features;

        this.setState({datas});

        projection.scale(1).translate([0, 0]);
        let b = path.bounds(featureData),
            s =
                0.95 /
                Math.max((b[1][0] - b[0][0]) / width, (b[1][1] - b[0][1]) / height),
            t = [
                (width - s * (b[1][0] + b[0][0])) / 2,
                (height - s * (b[1][1] + b[0][1])) / 2
            ];
        projection.scale(s).translate(t);

        g.selectAll("path")
            .data(datas)
            .enter()
            .append("path")
            .attr("class", d => `outline ${d.properties.DISTRICT}`)
            .attr("fill", d => {
                if (d.properties.DISTRICT != district.toUpperCase()) {
                    return "#ddd";
                } else {
                    let a = vdcColor[`${d.properties.N_WCode}`];
                    return getColor(a) || "#fff"
                }
            })
            .attr('stroke', function (d) {
                if (d.properties.DISTRICT == district.toUpperCase()) {
                    return "#656565";
                }
                return "none";
            })
            .attr("d", path)
            .attr("id", d => d.properties.WardCode)
            .attr("data-ward-code", d => d.properties.N_WCode);

        let self = this;
        let zoom = d3
            .zoom()
            // .scaleExtent([.95, 30])
            .on("zoom", function () {
                g.transition()
                    .duration(200)
                    .attr("transform", d3.event.transform);
            });
        // svg.call(zoom);
        let allBounds = [];
        d3.selectAll(`.${district.toUpperCase()}`)
            .attr("class", d => `${district.toUpperCase()} ${d.properties.GaPa_NaPa.split(" ").join("-")} outline current-district`)
            .each(d => allBounds.push(path.bounds(d)));

        let {scale, translate} = calculateTranslateAndScale(
            allBounds,
            this.state.width,
            this.state.height
        );
        let transform = d3.zoomIdentity
            .translate(translate[0], translate[1])
            .scale(scale);
        svg.call(zoom.transform, transform);

        if (svg && path && zoom) {
            this.setState({svg, path, zoom});
        }
    };

    readCSVFile = (districtName, csvData, filePath) => {
        let self = this;
        let csvFile =
            filePath && filePath.length > 0 ? filePath : "/map/po-activities-5w.csv";
        !csvData
            ? d3.csv(csvFile).then(function (data) {
                self.csvManupulation(districtName, data);
            })
            : this.csvManupulation(districtName, csvData);
    };

    csvManupulation = async (districtName, data) => {
        let columns = data.columns;
        data = data.filter(
            d => d.District.toUpperCase() === districtName.toUpperCase()
        );
        let {gapanas, sectors, partnerOrganizations, activityTypes} = await getDataForReactSelect(data);

        this.setState({
            gapanas,
            sectors,
            originalData: data,
            csvData: data,
            allCsvData: {data, columns},
            partnerOrganizations,
            activityTypes
        });
        this.poPresenceInnerTextStyle();
    };

    filterData = ({selectedGapanas, selectedPos, selectedActivities, selectedSectors, selectedActivityStatus}) => {
        let district = this.props.match.params.id;
        let mapWrapper = $("svg#map");
        let data = this.state.originalData;
        let {columns} = this.state.allCsvData;
        let isFilterable = (
            (selectedGapanas && selectedGapanas.length > 0) ||
            (selectedPos && selectedPos.length > 0) ||
            (selectedActivities && selectedActivities.length > 0) ||
            (selectedSectors && selectedSectors.length > 0) ||
            (selectedActivityStatus && selectedActivityStatus.length > 0)
        );

        let hasAuxFilters = (
            (selectedPos && selectedPos.length > 0) ||
            (selectedActivities && selectedActivities.length > 0) ||
            (selectedSectors && selectedSectors.length > 0) ||
            (selectedActivityStatus && selectedActivityStatus.length > 0)
        );

        if (isFilterable) {
            let resultData = data;
            if (selectedGapanas && selectedGapanas.length > 0) {
                let filteredData = [];
                selectedGapanas.map((value, i) => {
                    let result = resultData.filter(d => d["Municipality"] == value);
                    filteredData = filteredData.concat(result);
                })
                resultData = filteredData;
                mapWrapper.find("path.current-district")
                    .removeClass("selected-path less-opacity");
                selectedGapanas.map(data => {
                    mapWrapper
                        .find(`.${district.toUpperCase()}.${data.split(" ").join('-')}`)
                        .addClass("selected-path");
                });
                mapWrapper.find("path.current-district")
                    .not('.selected-path')
                    .addClass('less-opacity')

                if (!hasAuxFilters) {
                    let finalData = {data: resultData, columns};
                    this.setState({allCsvData: finalData});
                    return;
                }
            }

            if (selectedPos && selectedPos.length > 0) {
                let filteredData = [];
                selectedPos.map((value, i) => {
                    let result = resultData.filter(
                        d => d["Partner Organization"] === value
                    );
                    filteredData = filteredData.concat(result);
                })
                resultData = filteredData;
            }

            if (selectedSectors && selectedSectors.length > 0) {
                let filteredData = [];
                selectedSectors.map((value, i) => {
                    let result = resultData.filter(
                        d => d["Sector"] === value
                    );
                    filteredData = filteredData.concat(result);
                })
                resultData = filteredData;
            }

            if (selectedActivities && selectedActivities.length > 0) {
                let filteredData = [];
                selectedActivities.map((value, i) => {
                    let result = resultData.filter(
                        d => d["Activity Type"] === value
                    );
                    filteredData = filteredData.concat(result);
                })
                resultData = filteredData;
            }

            if (selectedActivityStatus && selectedActivityStatus.length > 0) {
                let filteredData = [];
                selectedActivityStatus.map((value, i) => {
                    let result = resultData.filter(
                        d => d["Activity Status"] === value
                    );
                    filteredData = filteredData.concat(result);
                })
                resultData = filteredData;
            }

            let wardCodes = d3.map(resultData, d => d["GaPaN_Ward_Code"]).keys();
            mapWrapper.find("path")
                .removeClass("selected-path")
                .removeClass('less-opacity');
            mapWrapper.find("path").each(function (d) {
                if (wardCodes.includes($(this).data("ward-code"))) {
                    $(this).addClass("selected-path");
                }
            });
            mapWrapper.find("path.current-district").not('.selected-path').addClass('less-opacity');
            let finalData = {data: resultData, columns};
            this.setState({allCsvData: finalData});
        } else {
            let districtName = this.props.match.params.id;
            mapWrapper
                .find(`.${districtName.toUpperCase()}`)
                .removeClass("selected-path less-opacity")
            ;
            let finalData = {data: this.state.originalData, columns};
            this.setState({allCsvData: finalData});
        }

    };

    handleFilterChange = (type, datas) => {
        this.setState({[type]: datas});
        let self = this;
        setTimeout(function () {
            const {selectedGapanas, selectedPos, selectedActivities, selectedSectors, selectedActivityStatus} = self.state;
            self.filterData({
                selectedGapanas,
                selectedPos,
                selectedActivities,
                selectedSectors,
                selectedActivityStatus
            });
        })
    }

    render() {
        let district = this.props.match.params.id;
        let { dashboards } = this.props;
        let dashboardDate =
            (dashboards &&
                dashboards['po-activities-5w'] &&
                dashboards['po-activities-5w'].date) ||
            "May 10, 2018";
        let {map, infographics, isEnglish, districtList} = this.props;
        let {
            gapanas,
            partnerOrganizations,
            activityTypes,
            sectors,
            meeting,
            team,
            resourceMaterials,
            allCsvData,
            selectedGapanas,
            selectedPos,
            selectedSectors,
            selectedActivityStatus
        } = this.state;
        resourceMaterials =
            resourceMaterials && chunkArray(resourceMaterials.data, 3);
        let mapData = map && map.data && chunkArray(map.data.sort(
            (a,b) => new Date(b.publish_date) - new Date(a.publish_date)
        ), 3);
        let infoData =
            infographics && infographics.data && chunkArray(infographics.data.sort(
            (a,b) => new Date(b.publish_date) - new Date(a.publish_date)
            ), 3);
        let meetingData = meeting && meeting.data && chunkArray(meeting.data.sort(
            (a,b) => new Date(b.start_date) - new Date(a.start_date)
        ), 3);
        let districtImage = null;
        let districtObj =
            districtList &&
            districtList.districtList &&
            districtList.districtList.filter(d => d.alias === district);

        let data =
            this.state && this.state.allCsvData && this.state.allCsvData.data;
        data =
            data &&
            data.map(data => {
                let result = {};
                requiredCols.map(col => {
                    result[col] = data[col];
                });
                return result;
            });
        if (districtObj && districtObj.length > 0) {
            districtImage = districtObj[0].header_image_file || districtObj[0].image_file;
        }
        let csvString =
            allCsvData &&
            allCsvData.data &&
            allCsvData.data.length > 0 &&
            convertArrayToCSV(allCsvData.data);
        return (
            <section id="district">
                <div className="districtBannder">
                    <img
                        src={districtImage ? host + districtImage : "/img/parallax.jpg"}
                        alt=""
                    />
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <h1 style={{
                                    background: "#2780cc",
                                    color: "#fff",
                                    opacity: ".9",
                                    padding: "5px"
                                }}>{district}</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="white-bckg">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="district-top">
                                    <div className="panel panel-default">
                                        <div className="panel-heading district-content-title">
                                            <div className="row">
                                                <div className="col-sm-9">
                                                    <h4>
                                                        Interactive Dashboards 
                                                        {/* {dashboardDate && `(${dashboardDate})`} */}
                                                    </h4>
                                                </div>
                                                <div className="col-sm-3">
                                                    {csvString && csvString.length > 0 && (
                                                        <a
                                                            className="pull-right"
                                                            target="_blank"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                download(csvString, getCsvFilename({
                                                                    districtName: district,
                                                                    selectedGapanas,
                                                                    selectedPos,
                                                                    selectedSectors,
                                                                    selectedActivityStatus
                                                                }));
                                                            }}
                                                        >
                                                            <i className="fa fa-share-square-o"/>
                                                            Export Data
                                                        </a>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="filter-section">
                                                <div className="row">
                                                    {gapanas && gapanas.length > 0 && (
                                                        <div className="col-xs-4">
                                                            <label>Municipalities</label>
                                                            <Select options={gapanas}
                                                                    isMulti={true}
                                                                    className="select-filter"
                                                                    placeholder="Select Municipalites"
                                                                    onChange={values => {
                                                                        values = values.map(d => d.value)
                                                                        this.handleFilterChange('selectedGapanas', values)
                                                                    }}/>
                                                        </div>
                                                    )}

                                                    {partnerOrganizations && partnerOrganizations.length > 0 && (
                                                        <div className="col-xs-4">
                                                            <label>Partner Organizations</label>
                                                            <Select options={partnerOrganizations}
                                                                    isMulti={true}
                                                                    className="select-filter"
                                                                    placeholder="Select Partner Organizations"
                                                                    onChange={values => {
                                                                        values = values.map(d => d.value)
                                                                        this.handleFilterChange('selectedPos', values)
                                                                    }}/>
                                                        </div>
                                                    )}

                                                    {activityTypes && activityTypes.length > 0 && (
                                                        <div className="col-xs-4">
                                                            <label>Activity Types</label>
                                                            <Select options={activityTypes}
                                                                    isMulti={true}
                                                                    className="select-filter"
                                                                    placeholder="Select Activity Types"
                                                                    onChange={values => {
                                                                        values = values.map(d => d.value)
                                                                        this.handleFilterChange('selectedActivities', values)
                                                                    }}/>
                                                        </div>
                                                    )}

                                                    <div className="clearfix"></div>

                                                    {sectors && sectors.length > 0 && (
                                                        <div className="col-xs-4">
                                                            <label>Sectors</label>
                                                            <Select options={sectors}
                                                                    isMulti={true}
                                                                    className="select-filter"
                                                                    placeholder="Select Sectors"
                                                                    onChange={values => {
                                                                        values = values.map(d => d.value)
                                                                        this.handleFilterChange('selectedSectors', values)
                                                                    }}/>
                                                        </div>
                                                    )}

                                                    <div className="col-xs-4">
                                                        <label>Activity Status</label>
                                                        <Select options={[
                                                            {label: "Completed", value: "Completed"},
                                                            {label: "Ongoing", value: "Ongoing"},
                                                            {label: "Planned", value: "Planned"},
                                                        ]}
                                                                isMulti={true}
                                                                className="select-filter"
                                                                placeholder="Select Activity Status"
                                                                clear
                                                                onChange={values => {
                                                                    values = values.map(d => d.value)
                                                                    this.handleFilterChange('selectedActivityStatus', values)
                                                                }}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel-body">
                                            <div className="map-section">
                                                <div className="row">
                                                    <div className="col-xs-12 col-sm-6 col-md-8">
                                                        <div className="well">
                                                            <div id="map-wrapper"/>
                                                            <PoPresenceLegend/>
                                                        </div>
                                                    </div>

                                                    <div className="col-xs-12 col-sm-6 col-md-4">
                                                        <div className="panel panel-primary fixed-height-panel">
                                                            <div className="panel-heading">
                                                                <h1 className="panel-title">Number of units</h1>
                                                            </div>
                                                            <div className="panel-body">
                                                                {this.state.allCsvData && (
                                                                    <PoActivityStatus
                                                                        districtName={district}
                                                                        allCsvData={allCsvData}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {this.state.allCsvData && (
                                                <PoActivities
                                                    districtName={district}
                                                    allCsvData={allCsvData}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {((mapData && mapData.length > 0) ||
                    (infoData && infoData.length > 0) ||
                    (meetingData && meetingData.length > 0) ||
                    (resourceMaterials && resourceMaterials.length > 0)) && (
                    <VerityOfData
                        district={district}
                        mapData={mapData}
                        infoData={infoData}
                        meetingData={meetingData}
                        resourceMaterials={resourceMaterials}
                        isEnglish={isEnglish}
                    />
                )}
                {team && team.length > 0 && <Team team={team} isEnglish={isEnglish}/>}
            </section>
        );
    }
}

const mapStateToProps = state => ({
    map: state.districtMapList.districtMapList,
    infographics: state.districtInfography.districtInfographyList,
    isEnglish: state.changeLanguage.isEnglish,
    csvData: state.csvData,
    mapData: state.mapData,
    districtList: state.districtList,
    dashboards: state.dashboards
});
export default connect(mapStateToProps)(District);